<section>
  <a
    type="button"
    [ngStyle]="{ background: authService.currentUserValue.empresaCorPadrao }"
    class="link-button"
    data-toggle="modal"
    data-target="#exampleModalCenter"
  >
    <img
      src="assets/images/icons/icon-flower-menu.svg"
      alt="Icon Flower Menu"
    />
    Canal de denúncias
  </a>

  <!-- Modal -->
  <div
    class="modal fade"
    id="exampleModalCenter"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>
            Você está prestes a ser direcionado para a plataforma do Canal de
            Denúncias que garante total confidencialidade e segurança para o
            denunciante. Não é necessário se identificar, mas é fundamental agir
            com responsabilidade ao efetuar relatos.
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="cancelar" data-dismiss="modal">
            Cancelar
          </button>
          <button
            type="button"
            class="continuar"
            (click)="canalDedenuncia()"
            data-dismiss="modal"
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

